import React, { useRef } from 'react';
import { Box, TextField } from '@mui/material';
import { ContentBlock } from '../../../types/blocks';
import VariableInsertButton from './VariableInsertButton';

interface TextBlockEditorProps {
  block: ContentBlock;
  onChange: (block: ContentBlock) => void;
}

const TextBlockEditor: React.FC<TextBlockEditorProps> = ({ block, onChange }) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const handleInsertVariable = (token: string) => {
    const textarea = inputRef.current;
    if (!textarea) {
      // Fallback: append to end
      onChange({ ...block, content: block.content + token });
      return;
    }

    const start = textarea.selectionStart ?? block.content.length;
    const end = textarea.selectionEnd ?? block.content.length;
    const before = block.content.slice(0, start);
    const after = block.content.slice(end);
    const newContent = before + token + after;
    onChange({ ...block, content: newContent });

    // Restore cursor position after the inserted token
    requestAnimationFrame(() => {
      const newPos = start + token.length;
      textarea.selectionStart = newPos;
      textarea.selectionEnd = newPos;
      textarea.focus();
    });
  };

  return (
    <Box>
      <TextField
        fullWidth
        multiline
        minRows={2}
        placeholder="Type something..."
        value={block.content}
        onChange={(e) => onChange({ ...block, content: e.target.value })}
        inputRef={inputRef}
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            fontSize: '0.875rem',
          },
        }}
      />
      <VariableInsertButton onInsert={handleInsertVariable} />
    </Box>
  );
};

export default TextBlockEditor;
